import React, {useContext} from 'react';
import './style.scss';
import PropTypes from "prop-types";
import {brandContext} from "../../../store/brandContext";

/**
 * Копирайт
 *
 * @param {Object} props
 * @param {String} [props.bkString=Букмекерская_контора_Зенит] Верхняя строка с брендом
 * @param {String} [props.rightString=Все_права_защищены] Нижняя строка с копирайтом
 * @returns {JSX.Element}
 * @constructor
 */
const Copyright = ({bkString, rightString}) => {
  const currentYear = new Date().getFullYear();
  const brandName = useContext(brandContext);
  /**
   * Получить год начала существования текущего Бренда
   * @returns {string} Год
   */
  const getFromYear = () => {
    const brandsFrom = {
      zenit: '1998 -',
      zenbet: '2020 -',
      cupis: '1998 -',
    };
    return brandsFrom[brandName];
  };

  return (
    <div className='copyright-text'>
            <span>
                {getFromYear()} {currentYear} {bkString}
            </span>
      <span>&copy;&nbsp;{rightString}</span>
    </div>
  );
};

Copyright.propTypes = {
    bkString: PropTypes.string,
    rightString: PropTypes.string
};

Copyright.defaultProps = {
    bkString: 'Букмекерская контора Зенит',
    rightString: 'Все права защищены'
};

export default Copyright;
